import { render, staticRenderFns } from "./Page-6.vue?vue&type=template&id=123203dd&scoped=true&"
var script = {}
import style0 from "./Page-6.vue?vue&type=style&index=0&id=123203dd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123203dd",
  null
  
)

export default component.exports